const resources = {
    en: {
        translation: {
            terms_and_services_name: 'Republican Ads LLC',

            website_domain: 'RepublicanAds.com',
            meta_title_suffix: 'Republican Ads',

            support_email: 'support@republicanads.com',

            support_contact_email: 'support@Republicanads.com',
            support_contact_name: 'Joseph',

            url_tos: 'https://www.republicanads.com/terms-of-use/',
            url_help: 'https://www.republicanads.com/help/',
            url_contact: 'https://www.republicanads.com/contact',

            campaign_asset_best_practises_text: 'Ad FAQs',
            campaign_asset_best_practises_url:
                'https://www.republicanads.com/help',

            zoho_signin_hint:
                'Sign in with the Zoho account that owns the RepublicanAds.com CRM portal.'
        }
    }
}

export default resources
